module.exports = __webpack_public_path__ + "static/media/BITI-BNB.aa8c1fba.png";